/**
 * LandingMission Component
 *
 * Mission statement section with scroll-triggered animations.
 * Displays the "Mission launch" quote about entrepreneurship.
 */
"use client";

import { AnimatedSection } from "@/components/atoms/AnimatedSection";

export function LandingMission() {
  return (
    <section className="bg-landing-bg-light flex flex-col items-center justify-center py-[124px] pb-[160px] px-4">
      <div className="w-full max-w-[824px]">
        <AnimatedSection delay={0}>
          <div className="bg-landing-bg-medium inline-block px-2.5 py-2 rounded-md mb-8">
            <span className="font-mono text-sm text-landing-dark/80 uppercase">
              Mission launch
            </span>
          </div>
        </AnimatedSection>
        <AnimatedSection delay={0.1}>
          <p className="text-[28px] md:text-[36px] text-landing-dark leading-[1.3] tracking-tight">
            A new era of entrepreneurship is here. When anyone can build, clarity becomes the edge.
            Lev helps founders navigate the chaos: turning ideas into informed decisions.
          </p>
        </AnimatedSection>
      </div>
    </section>
  );
}
